import { useEffect } from 'react';

export interface ListenerProps {
    target: EventTarget;
    event: string;
    callback: (e: Event) => any;
}

export const Listener = ({ target, event, callback }: ListenerProps) => {
    useEffect(() => {
        target.addEventListener(event, callback);
        return () => target.removeEventListener(event, callback);
        // eslint-disable-next-line
    }, [target, event, callback]);
    return null;
};
